import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  firstName: "",
  lastName: "",
  gender: "",
  dob: "",
  photo: null, // { dataUrl, name, type } | null
  avatarId: null,
  country: null,
  city: null,
  language: null,
  currency: "INR",
  travelNodeAnswers: {}, // { [questionId]: [selectedOptionId, ...] }
  notes: "",
  lastStep: null, // path of the last account-setup step the user was on — lets a resumed session (closed tab, reload) send them back to where they left off
};

const profileSetupSlice = createSlice({
  name: "profileSetup",
  initialState,
  reducers: {
    updateProfileSetup: (state, action) => {
      Object.assign(state, action.payload);
    },
    resetProfileSetup: () => initialState,
  },
});

export const { updateProfileSetup, resetProfileSetup } = profileSetupSlice.actions;
export default profileSetupSlice.reducer;
